import { RTKQueryResponse, Response } from "@b2bportal/core-types";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { ensureExhaustive } from "./types";

export const mapQueryResponse = <Data, Error, NewData>(
  rtkResponse: RTKQueryResponse<Data, Error>,
  mapData: (data: Data) => NewData
): Response<NewData, Error> => {
  const response = transformRTKQueryToResponseType(rtkResponse);
  switch (response.status) {
    case QueryStatus.uninitialized:
      return { ...response, data: undefined };
    case QueryStatus.pending:
      if (response.data == null) {
        return { ...response, data: undefined };
      }
      return {
        ...response,
        data: mapData(response.data),
      };
    case QueryStatus.fulfilled:
      return {
        ...response,
        data: mapData(response.data),
      };
    case QueryStatus.rejected: {
      return { ...response, data: undefined };
    }
  }
};

export const transformRTKQueryToResponseType = <D, E>(
  rtkResponse: RTKQueryResponse<D, E>
): Response<D, E> => {
  switch (rtkResponse.status) {
    case QueryStatus.uninitialized:
      return {
        status: QueryStatus.uninitialized,
        isLoading: false,
        isSuccess: false,
        isError: false,
        isUninitialized: true,
        data: undefined,
        error: undefined,
      };

    case QueryStatus.pending:
      return {
        status: QueryStatus.pending,
        isLoading: true,
        isSuccess: false,
        isError: false,
        isUninitialized: false,
        data: rtkResponse.data,
        error: undefined,
      };

    case QueryStatus.fulfilled:
      return {
        status: QueryStatus.fulfilled,
        isLoading: false,
        isSuccess: true,
        isError: false,
        isUninitialized: false,
        data: rtkResponse.data!,
        error: undefined,
      };

    case QueryStatus.rejected:
      return {
        status: QueryStatus.rejected,
        isLoading: false,
        isSuccess: false,
        isError: true,
        isUninitialized: false,
        data: undefined,
        error: rtkResponse.error!,
      };

    default:
      ensureExhaustive(rtkResponse.status);
  }
};
